<template>
    <div class="shop-filter-field" :class="{'shop-filter-field--compact': compact}">
        <p v-if="!compact" class="shop-filter-label">{{ formField.title }}</p>

        <div class="shop-filter-options">
            <el-checkbox
                v-for="option in formField.options"
                :key="option.id"
                :checked="value?.includes(option.title)"
                :value="value"
                @change="handleOnChange(option.title)"
                :label="option.title"
                class="shop-filter-checkbox"
            >
                {{ option.title }}
            </el-checkbox>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Checkbox',
    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: [],
        }
    },

    methods: {
        handleOnChange(value) {
            const valueCopy = [...this.value];

            if (valueCopy.includes(value)) {
                valueCopy.splice(valueCopy.indexOf(value), 1);
            } else {
                valueCopy.push(value);
            }

            this.value = valueCopy;

            this.onChangeHandler(
                `additional_data[${this.formField.slug}]`,
                valueCopy.length ? valueCopy : null,
                true
            )
        }
    },

    mounted() {
        if (this.selectedFilters[`additional_data[${this.formField.slug}]`] ?? false) {
            this.value = this.selectedFilters[`additional_data[${this.formField.slug}]`].split('%2C').map(item => {
                return item.replace('+', ' ')
            });
        }
    }
}
</script>
